var map = {
	"./feature_buy_en.png": 14869,
	"./feature_buy_id.png": 97435,
	"./feature_buy_ko.png": 92254,
	"./feature_buy_ph.png": 57140,
	"./feature_buy_th.png": 99112,
	"./feature_buy_zh.png": 41014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82935;